import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@chakra-ui/react';
import type { CrmPalette } from '@src/components/sco/Admin/AiCrm/crmLane';
import React from 'react';

/** Initials on a colored tile. Round in a thread, rounded-square on a profile, as in the handoff. */
export function CrmAvatar(props) {
  const $ = _c(7);
  const t0 = props.tone || "orange";
  const t1 = props.square ? "rounded" : "full";
  const t2 = props.size || "md";
  let t3;
  if ($[0] !== props.name) {
    t3 = <Avatar.Fallback name={props.name} />;
    $[0] = props.name;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = <Avatar.Root aria-hidden={true} colorPalette={t0} flexShrink={0} shape={t1} size={t2} variant="solid">{t3}</Avatar.Root>;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}